import React from 'react';
import { Facebook, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo, socialMedia, locationInfo } from '../mockData';

const Footer = () => {
  const getSocialIcon = (iconName) => {
    const icons = {
      facebook: Facebook,
      twitter: Twitter,
      linkedin: Linkedin
    };
    const Icon = icons[iconName];
    return Icon ? <Icon size={20} /> : null;
  };

  return (
    <footer className="footer">
      <div className="footer-gradient-overlay"></div>
      
      <div className="footer-content">
        <div className="footer-grid">
          {/* Logo y Nombre de la Empresa */}
          <div className="footer-brand">
            <div className="footer-logo-container">
              <img src={companyInfo.logo} alt={companyInfo.name} className="footer-logo" />
            </div>
            <h3 className="footer-company-name">{companyInfo.name}</h3>
            <p className="footer-company-fullname">{companyInfo.fullName}</p>
            <p className="footer-slogan">{companyInfo.slogan}</p>
          </div>

          {/* Contacto */}
          <div className="footer-section">
            <h4 className="footer-title">Contacto</h4>
            <ul className="footer-contact-list">
              <li className="footer-contact-item">
                <Phone size={16} />
                <span>{locationInfo.phone}</span>
              </li>
              <li className="footer-contact-item">
                <Mail size={16} />
                <span>{locationInfo.email}</span>
              </li>
              <li className="footer-contact-item">
                <MapPin size={16} />
                <span>{locationInfo.address}</span>
              </li>
            </ul>
          </div>

          {/* Horarios */}
          <div className="footer-section">
            <h4 className="footer-title">Horarios</h4>
            <p className="footer-hours">{locationInfo.hours}</p>
          </div>

          {/* Redes Sociales */}
          <div className="footer-section">
            <h4 className="footer-title">Síguenos</h4>
            <div className="footer-social">
              {socialMedia.map((social) => (
                <a
                  key={social.name}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link"
                  aria-label={social.name}
                >
                  {getSocialIcon(social.icon)}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-copyright">
            © {new Date().getFullYear()} {companyInfo.fullName}. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
